import clsx from "clsx";
import { useEnvContext } from "context/EnvContext";
import { APP_B2C } from "core/consts";
import { AppName } from "core/types";
import LanguageFab from "ds_legacy/components/FlagFab";
import { SpinnerPage } from "ds_legacy/components/Spinner";
import { margin } from "ds_legacy/materials/metrics";
import { usePrint } from "dsl/atoms/Contexts";
import PrintOverlay from "dsl/atoms/PrintOverlay";
import { useEnvironmentSwitcher } from "dsl/hooks";
import useLoadFavicon from "dsl/hooks/useLoadFavicon";
import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";

export default function RootPage({
  appName,
  children,
}: {
  appName: AppName;
  children?: React.ReactNode;
}) {
  const { app } = useEnvContext();
  const print = usePrint();

  useLoadFavicon();
  useEnvironmentSwitcher();

  return (
    <div
      className={clsx(
        "min-h-screen flex-1 print:block print:h-auto print:min-h-0 print:break-inside-avoid",
        {
          block: print,
          flex: !print,
          "flex-col": app !== APP_B2C,
          "flex-row": app === APP_B2C,
        },
      )}
      style={{
        ...(print ? { margin: margin(0, 2) } : {}),
      }}
    >
      <PrintOverlay />
      <LanguageFab />
      <Suspense
        fallback={
          <SpinnerPage height="100%" id={`suspense-router-${appName}`} />
        }
      >
        {children ?? <Outlet />}
      </Suspense>
    </div>
  );
}
